export default __webpack_public_path__ + "static/clinic_card_mobile-da8eff4ec2e32de94c15480a36c34d60.png";